import React from 'react'

const tableHeaderStyle = 'border p-[8px] text-start font-normal'
const tableCellStyle = 'border-b border-l border-r p-[10px]'

const Receipt = () => {
    return (
        <div className="p-4 ">
            <div className='flex justify-between'>
                <div>
                    <img src="/geeksdoor_logo.jpg" alt="geeksdoor logo" />
                </div>
                <div className='flex flex-col items-end'>
                    <p className='font-bold text-slate-600 text-xl'> RECEIPT</p>
                    <p className='font-semibold text-slate-600'>#GDREC-210501</p>
                    <p className='text-green-400 font-semibold'> PAID</p>
                </div>
            </div>

            <div className='my-4 flex justify-between'>
                <div className='flex flex-col'>
                    <span className='font-bold text-slate-600'>GeeksDoor</span>
                    <span>303 Prabhdeep 11 Indrapuri Bhanwarkua</span>
                    <span>Indore Madhya Pradesh</span>
                    <span>India 452001</span>

                </div>
                <div className='flex flex-col items-end '>
                    <span className='font-bold text-slate-600'>Bill To</span>
                    <span className='font-bold text-slate-600'>Taha Mansuri</span>
                    <span>270B, Green Park Colony Indore</span>
                    <span>Indore Madhya Pradesh</span>
                    <span>IN 452001</span>
                </div>
            </div>

            <div className='my-4 flex justify-end'>
                <div className='flex flex-col items-end'>
                    <span>Receipt Date: 26-10-2021</span>
                    <span>Due Date: 06-12-2021</span>
                </div>
            </div>

            <div style={{ width: '100%', margin: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
                    <thead>
                        <tr className='bg-zinc-500 text-white'>
                            <th className={tableHeaderStyle}>#</th>
                            <th className={tableHeaderStyle}>Course</th>

                            <th className={tableHeaderStyle}>Total fees</th>
                            <th className={tableHeaderStyle}>Paid</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className={tableCellStyle}>1</td>
                            <td className={`${tableCellStyle} flex flex-col`}>
                                <p className='font-semibold text-slate-600 '>MERN Stack on Job Training</p>
                                <p>For Full Stack Development</p>
                            </td>

                            <td className={tableCellStyle}>35,000.00</td>
                            <td className={tableCellStyle}>35,000.00</td>
                        </tr>
                    </tbody>

                </table>
            </div>
            <div className=' flex justify-end my-4'>
                <div className='flex flex-col'>
                    <div className='flex items-end  pr-5'>
                        <div className='font-semibold text-slate-600 w-[150px] text-end '>Sub Total</div>
                        <div className='w-[150px] text-end' >3500,00</div>
                    </div>
                    <div className='flex items-end  pr-5'>
                        <div className='font-semibold text-slate-600 w-[150px] text-end'>Discount</div>
                        <div className='w-[150px] text-end'>3500,00</div>
                    </div>
                </div>
            </div>


            <div className='bg-slate-100 rounded p-1 my-2'>
                <div className='flex justify-end pr-5'>
                    <div className='flex items-end '>
                        <div className='font-semibold text-slate-600 w-[150px] text-end '>Total</div>
                        <div className='w-[150px] text-end'>₹20,000.00</div>
                    </div>
                </div>
                <div className='flex justify-end pr-5'>
                    <div className='flex '>
                        <div className='font-semibold text-slate-600 w-[150px] text-end'>Amount Due</div>
                        <div className='w-[150px] text-end'>₹0.00</div>
                    </div>
                </div>
            </div>

            <div className='flex justify-center my-4 font-semibold text-slate-600 text-md'>
                <span>With words:  Twenty Thousand</span>
            </div>

            <div>
                <span className='font-semibold text-slate-600 text-md'>Transactions</span>
                <div style={{ width: '100%', margin: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
                        <thead >
                            <tr className='bg-zinc-500 text-white mx-auto'>
                                <th className={tableHeaderStyle}>Payment</th>
                                <th className={tableHeaderStyle}>Payment Mode</th>
                                <th className={tableHeaderStyle}>Date</th>
                                <th className={tableHeaderStyle}>Amount</th>
                            </tr>
                        </thead>
                        <tbody className='mx-auto'>
                            <tr>
                                <td className={tableCellStyle}>20</td>
                                <td className={tableCellStyle}>CASH</td>
                                <td className={tableCellStyle}>26-10-2021</td>
                                <td className={tableCellStyle}>₹10,000.00</td>
                            </tr>
                            <tr>
                                <td className={tableCellStyle}>20</td>
                                <td className={tableCellStyle}>CASH</td>
                                <td className={tableCellStyle}>26-10-2021</td>
                                <td className={tableCellStyle}>₹10,000.00</td>
                            </tr>
                        </tbody>

                    </table>
                </div>
            </div>

            <div className='mt-20'>
                Authorized Signature
            </div>
        </div>
    )
}

export default Receipt